<template>
  <div class="p-box-wrap">
    <div class="p-box-name">
      {{ title_box }}
      <img
        src="@/assets/images/dropdown.svg"
        alt="drop"
        :class="['dropdown_icon', { 'rotate-180': !isShowContent }]"
        @click="isShowContent = !isShowContent"
      />
    </div>
    <div class="p-box-content" v-show="isShowContent">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  title_box: {
    type: String,
  },
});

const isShowContent = ref(true);
</script>

<style lang="scss">
.p-box-wrap {
  flex-basis: 100%;
  .p-box-name {
    background-color: #f0f1f4;
    border-left: 4px solid #626262;
    padding: 13px 20px;
    font-weight: 700;
    font-size: 18px;
    margin-bottom: 10px;
    flex-basis: 100%;

    .dropdown_icon {
      display: none;
    }
  }
  .p-box-content {
    display: flex;
    flex-flow: row wrap;
  }
}
@media screen and (max-width: 1024px) {
  .p-box-wrap {
    .p-box-name {
      padding: 13px 18px;
      margin-bottom: 20px;
      position: relative;

      .dropdown_icon {
        position: absolute;
        top: 20px;
        right: 10px;
        width: 18px;
        height: 10px;
        display: block;
      }
      .rotate-180 {
        transform: rotate(180deg);
      }
    }
  }
}
</style>
